import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "textNormalize",
    standalone: false
})
export class TextNormalizationPipe implements PipeTransform {
    public transform(value: string, args?: any): string {
        let phrase: string = value
            .split(/(?=[A-Z])/g)
            .map((word) => {
                const trimmedWord = word.trim();
                trimmedWord[0]?.toLocaleUpperCase();
                return trimmedWord;
            })
            .join(" ");
        phrase = phrase.charAt(0).toLocaleUpperCase() + phrase.slice(1);

        return phrase;
    }
}
